import React from 'react';
import Layout from '../components/Layout';
import FlavorTree from '../components/FlavorTree';
import strainTreeData from '../data/strainTree.json';
import '../styles/StrainPage.css';

const StrainPage = ({ strain }) => {
  const isAuth = sessionStorage.getItem('auth') === 'true';
  const strainData = strainTreeData[strain];

  if (!strainData) {
    if (isAuth) {
      return (
        <Layout>
          <div className="strain-page-content">
            <div className="error-message">
              <h2>Error</h2>
              <p>Strain "{strain}" not found in database.</p>
            </div>
          </div>
        </Layout>
      );
    }
    return (
      <div className="public-strain-page">
        <div className="error-message">
          <h2>Strain not found</h2>
        </div>
      </div>
    );
  }

  // Authenticated users get the full app layout with sidebar/header
  if (isAuth) {
    return (
      <Layout>
        <div className="strain-page-content">
          <FlavorTree strainData={strainData} />
        </div>
      </Layout>
    );
  }

  // Public users get a plain page — just the tree, no sidebar or header
  return (
    <div className="public-strain-page">
      <div className="public-strain-content">
        <FlavorTree strainData={strainData} />
      </div>
    </div>
  );
};

export default StrainPage;
